export const CUSTOM = 0;
export const HIT = 1;
export const MEASURE = 2;
export const EXCEPTION = 3;
export const SCREEN = 4;
export const SOCIAL = 5;
export const EVENT = 6;
